import {AbsctractValidator} from "./AbstractValidator";

export class RegexValidator extends AbsctractValidator {
    constructor(input, regex) {
        super(input);
        this.regex = regex;
    }

    isValid() {
        if (this.input) {
            return this.regex.test(this.input);
        }
        return false;
    };

    message() {
        return this.isValid() ? "OK" : "Erro de validação"
    };
}


// WEBPACK FOOTER //
// ./src/validator/RegexValidators.js